import { render } from "./CameraLabelsNew.vue?vue&type=template&id=08e1082d&ts=true"
import script from "./CameraLabelsNew.vue?vue&type=script&lang=ts"
export * from "./CameraLabelsNew.vue?vue&type=script&lang=ts"

import "./CameraLabelsNew.vue?vue&type=style&index=0&id=08e1082d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__